module.exports = __webpack_public_path__ + "img/chevron-right.1dc725f6.svg";